import { DataHeader, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommDriverError extends Layout {
    dataheaderMobileCommGroup: DataHeader;
    labelIsActive: Switch;
    panelMobileCommGroup: Panel;
    sourcMCError: DataSource;
    textboxDescr: Textbox;
    textboxDriverMessage: Textbox;
    textboxID: Textbox;
}
